import { useContext } from 'react';
import type { SegmentSchemaCatalogContextValue } from './segment-schema-catalog-context';
import { SegmentSchemaCatalogContext } from './segment-schema-catalog-context';

/** Read the schema catalog supplied by the active visual segment builder. */
export function useSegmentSchemaCatalog(): SegmentSchemaCatalogContextValue {
  const value = useContext(SegmentSchemaCatalogContext);
  if (!value)
    throw new Error('useSegmentSchemaCatalog must be used within SegmentSchemaCatalogProvider');
  return value;
}
